export default __webpack_public_path__ + "static/media/Tasset of the Proven Champion.f82643c3.jpg";